import axios from "axios";
import settings from "../../settings/index"

export const doLogin = (email, password) => {
    return axios.post(settings.auth_server_api + "/auth/oauth2/token", {
        username: email,
        password: password,
        client_id : process.env.REACT_APP_ASSET_MGMT_WEB_API_KEY,
        client_secret : process.env.REACT_APP_ASSET_MGMT_WEB_API_SECRET,
        grant_type : "password",
    }).then(res => res.data).catch((error) => {
        if (!error.response && !error.response.data && !error.response.data.errors && error.response.data.errors.length < 1){
            throw error;
        }
        return error.response.data.errors;
    });
};

export const postUser = (user) => {
    return axios.post(settings.auth_server_api + "/register", {
        ...user,
        client_id : process.env.REACT_APP_ASSET_MGMT_WEB_API_KEY,
        client_secret : process.env.REACT_APP_ASSET_MGMT_WEB_API_SECRET,
    }).then(res => res.data).catch((error) => {
        throw error;
    });
};

export const postPassRequest = (email) => {
    return axios.post(settings.auth_server_api + "/accounts/password/reset", {
        email,
        client_id : process.env.REACT_APP_ASSET_MGMT_WEB_API_KEY,
        client_secret : process.env.REACT_APP_ASSET_MGMT_WEB_API_SECRET,
    }).then(res => res.data.data).catch((error) => {
        if (!error.response && !error.response.data && !error.response.data.errors && error.response.data.errors.length < 1){
            throw error;
        }
        return error.response.data.errors;
    });
};

export const authenticateUser = (id_token) => {
    return axios.post(settings.asset_mgmt_api + "/auth/login", {
        id_token,
    })
    .then(res => res.data.data).catch((error) => {
        if (!error.response && !error.response.data && !error.response.data.errors && error.response.data.errors.length < 1){
            throw error;
        }
        return error.response.data.errors;
    });
};
